import { LPSettlementBatchStatusEnum } from '@talos/kyoko';
import { LPSettlementBatchesGrid } from '../LPSettlementBatchesGrid/LPSettlementBatchesGrid';

const BATCH_HISTORY_STATUSES: LPSettlementBatchStatusEnum[] = [
  LPSettlementBatchStatusEnum.Settled,
  LPSettlementBatchStatusEnum.CanceledPartiallySettled,
  LPSettlementBatchStatusEnum.Discarded,
];

export function BatchHistory() {
  return (
    <LPSettlementBatchesGrid
      blotterID="batch-history"
      BatchStatuses={BATCH_HISTORY_STATUSES}
      exportName="Batch History"
      mode="batchHistory"
    />
  );
}
